module.exports = __webpack_public_path__ + "img/schema_selle_1b.5103808d.svg";